import { render, staticRenderFns } from "./PaymentRecipientInfo.vue?vue&type=template&id=7b24a11c&scoped=true&"
import script from "./PaymentRecipientInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentRecipientInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRecipientInfo.vue?vue&type=style&index=0&id=7b24a11c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b24a11c",
  null
  
)

export default component.exports